import { SCHEMA_VERSION } from '@oneappexchange/oaf-schema';
import { LISTING_SERVICE_API_VERSION, PUBLISHER_URL } from '~/modules/config';
import { getListingResponse, ListingResponse } from '~/modules/services/listing_service';
import { shouldTransformResponse } from '~/modules/utilities/axios_utilities';
import { http, HttpRequestConfig } from '~/modules/utilities/http';
import { Marketplace } from '~/modules/utilities/language_utils';

// @ts-expect-error * Automated Type Error Fix
const parseResponse = (response) => {
    // @ts-expect-error * Automated Type Error Fix
    return response.map((listing) => {
        return getListingResponse(listing);
    });
};
const config: HttpRequestConfig = {
    headers: {
        Version: LISTING_SERVICE_API_VERSION || '1',
        SchemaVersion: SCHEMA_VERSION,
    },
    transformResponse: [
        (data, _headers, status) => {
            if (!shouldTransformResponse(status)) {
                return data;
            }
            return data ? JSON.parse(data) : undefined;
        },
        (data, _headers, status) => {
            if (!shouldTransformResponse(status)) {
                return data;
            }
            return data ? parseResponse(data) : undefined;
        },
    ],
};

const PARAM_EXLUDE_LISTING_ID = 'excludeListingId';
const PARAM_MARKETPLACE = 'marketplace';
const PARAM_COUNT = 'count';

export async function getPublisherListings(
    publisherId: string,
    listingId: string,
    marketplace: Marketplace = 'English',
    count?: number,
): Promise<ListingResponse[]> {
    // `count` is appended only when provided, so callers that omit it get the
    // service's default page size (the listing-detail page passes
    // `V2_PROVIDER_LISTINGS_TO_DISPLAY`). See docs/W-23636498-overviewv2-changes.md.
    let url = `${PUBLISHER_URL}/${publisherId}/listings?${PARAM_EXLUDE_LISTING_ID}=${listingId}&${PARAM_MARKETPLACE}=${marketplace}`;
    if (count !== undefined) {
        url += `&${PARAM_COUNT}=${count}`;
    }
    return http.get(url, config).then((response) => response?.data);
}
